import { lottieAnimations } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Box, Typography, SxProps, Theme } from '@mui/material';
import { motion } from 'framer-motion';
import Lottie from 'lottie-react';

export const TypingIndicator = () => (
  <Box sx={typingContainerStyle}>
    <Box sx={lottieContainerStyle}>
      <Lottie animationData={lottieAnimations.lubavLoader} height={26} width={26} />
    </Box>
    <Box sx={typingTextContainerStyle}>
      <Typography sx={lubavThinkingTextStyle}>
        {appStrings.modules.chatBox.lubavThinking}
      </Typography>
      <motion.div
        initial={{ x: '-100%' }}
        animate={{ x: '100%' }}
        transition={{
          duration: 1,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
        style={typingAnimationStyle}
      />
    </Box>
  </Box>
);

const typingContainerStyle: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  height: '30px',
  marginTop: '10px',
  marginLeft: '-2px',
};

const lottieContainerStyle: SxProps<Theme> = {
  width: 30,
  height: 30,
};

const typingTextContainerStyle: SxProps<Theme> = {
  position: 'relative',
  overflow: 'hidden',
  marginLeft: '16px',
};

const lubavThinkingTextStyle: SxProps<Theme> = {
  fontSize: '11pt',
  color: '#808080',
  position: 'relative',
  zIndex: 1,
};

const typingAnimationStyle: React.CSSProperties = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.5), transparent)',
  zIndex: 2,
} as const;
